import { Flex } from 'antd';

import { useState } from 'react';
import { MButton, TabButton } from '@Components/Base';
import { ViewTab } from '../ViewTab.enum';
import { DetailsTab, DocumentsTab, MaterialsTab } from '../components';

import styles from './view-mobile-form.module.css';

interface RequestViewMobileFormProps {
  onDelete: (requestNo: string) => void;
  onCancel: () => void;
}

const TenderRequestViewMobileForm: React.FC<
  RequestViewMobileFormProps
> = () => {
  const [activeTab, setActiveTab] = useState(ViewTab.DETAILS);

  return (
    <Flex vertical>
      <div className={styles.viewMobileForm}>
        <TabButton>
          <MButton onClick={() => setActiveTab(ViewTab.DETAILS)} type="text">
            Details
          </MButton>
          <MButton onClick={() => setActiveTab(ViewTab.MATERIALS)} type="text">
            Materials
          </MButton>
          <MButton onClick={() => setActiveTab(ViewTab.DOCUMENTS)} type="text">
            Documents
          </MButton>
        </TabButton>
        {activeTab === ViewTab.DETAILS && <DetailsTab />}
        {activeTab === ViewTab.MATERIALS && <MaterialsTab />}
        {activeTab === ViewTab.DOCUMENTS && <DocumentsTab />}
      </div>
    </Flex>
  );
};

export default TenderRequestViewMobileForm;
